import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import {
    getTankPressures,
  
    getTankASME8BarSizes,
    getTankASME10BarSizes,
    getTankASME13BarSizes
} from "../../constants/sizing-constant";
import { Link } from "react-router-dom";

export default class tankAsmeSizing extends Component {

    state = {
        presureTypes: [],
        selectedPresureType: "0",

        tankSizes: [],
        selectedTankSize: "0",

        showSizeType: false,

        suggestedModel: "",
        suggestedModelId: ""
    };

    componentDidMount() {
        this.setState({ presureTypes: [...getTankPressures()] });
    };

    componentWillReceiveProps(Values) {
        this.setState({ products: Values.products });
    };

    handlePressureSelect = presureTypes => {
        if (presureTypes) {
            this.setState({ selectedPresureType: presureTypes.value });
            if (presureTypes.value === "1") {
                this.setState({ tankSizes: [...getTankASME8BarSizes()] });
            }
            if (presureTypes.value === "2") {
                this.setState({ tankSizes: [...getTankASME10BarSizes()] });
            }
            if (presureTypes.value === "3") {
                this.setState({ tankSizes: [...getTankASME13BarSizes()] });
            }
            if (presureTypes.value === "4") {
                this.setState({ showSizeType: false });
            }
            else {
                this.setState({ showSizeType: true });

            }
        }
    };

    handleSizeSelect = size => {
        if (size) {
            this.setState({ selectedTankSize: size.value }, () => {
                this.findModel();
            });
        }
    };

    findModel() {
        const selectedPresureType = this.state.selectedPresureType;
        const selectedTankSize = this.state.selectedTankSize;
        if (selectedTankSize === "1") {
            this.setState({ suggestedModel: "AR1000 ASME" });
            this.setState({ suggestedModelId: "169" });
            return;
        }
        else if (selectedTankSize === "2") {
            this.setState({ suggestedModel: "AR1500 ASME" });
            this.setState({ suggestedModelId: "170" });
            return;
        }
        else if (selectedTankSize === "3") {
            this.setState({ suggestedModel: "AR2000 ASME" });
            this.setState({ suggestedModelId: "171" });
            return;
        }
        else if (selectedTankSize === "4") {
            this.setState({ suggestedModel: "AR2500 ASME" });
            this.setState({ suggestedModelId: "172" });
            return;
        }
        else if (selectedTankSize === "5") {
            this.setState({ suggestedModel: "AR3000 ASME" });
            this.setState({ suggestedModelId: "173" });
            return;
        }
        else if (selectedTankSize === "6") {
            this.setState({ suggestedModel: "AR3500 ASME" });
            this.setState({ suggestedModelId: "174" });
            return;
        }
        else if (selectedTankSize === "7") {
            this.setState({ suggestedModel: "AR4000 ASME" });
            this.setState({ suggestedModelId: "175" });
            return;
        }
        else if (selectedTankSize === "8") {
            this.setState({ suggestedModel: "AR5000 ASME" });
            this.setState({ suggestedModelId: "176" });
            return;
        }
        else if (selectedTankSize === "9") {
            this.setState({ suggestedModel: "AR6000 ASME" });
            this.setState({ suggestedModelId: "177" });
            return;
        }
        else if (selectedTankSize === "10") {
            this.setState({ suggestedModel: "AR8000 ASME" });
            this.setState({ suggestedModelId: "178" });
            return;
        }
        else if (selectedTankSize === "11") {
            this.setState({ suggestedModel: "AR10000 ASME" });
            this.setState({ suggestedModelId: "179" });
            return;
        }
        else if (selectedTankSize === "12") {
            this.setState({ suggestedModel: "تماس با کارشناس" });
            this.setState({ suggestedModelId: "180" });
            return;
        }
    }

    render() {
        return (
            <Fragment>
                <DropDownWhiteStyle
                    items={this.state.presureTypes}
                    placeholder="فشار مخزن"
                    onItemSelect={this.handlePressureSelect}
                    value={this.state.selectedPresureType}
                />
                {this.state.showSizeType &&
                    <Fragment>
                        <DropDownWhiteStyle
                            items={this.state.tankSizes}
                            placeholder="حجم مخزن"
                            onItemSelect={this.handleSizeSelect}
                            value={this.state.selectedTankSize}
                        />
                        {this.state.selectedTankSize !=="0" &&
                            <Fragment>
                                <h1 className="text-title-body">مدل پیشنهادی برای شما :</h1>
                                <div className="modelheadbox">
                                    <h1 >{this.state.suggestedModel}</h1>
                                    <hr className="divider" />
                                </div>
                                
                                <div className="row hrow mt-4">
                                    <Link className="btn btn-dark" to={`/partRequst/${this.state.suggestedModelId}`} >درخواست خرید این مدل</Link>
                                </div>
                            </Fragment>
                        }
                    </Fragment>
                }
                {this.state.selectedPresureType === "4" &&
                    <Fragment>
                        <h1 className="text-title-body">تماس با کارشناس</h1>
                        <div className="modelheadbox">
                            <hr className="divider" />
                        </div>
                        <div className="row hrow mt-4">
                            <Link className="btn btn-dark" to={`/consuling`} >درخواست خرید</Link>
                        </div>
                    </Fragment>
                }
            </Fragment>
        );
    }
}
